var NavMessageComponent = /** @class */ (function () {
    function NavMessageComponent() {
    }
    return NavMessageComponent;
}());
export { NavMessageComponent };
